import { CustomValueContainer } from '@/design-system/select/selectV1';
import React from 'react';

export const useFilterCustomFields = ({
  customFilterConfig,
  expanded,
  name,
  selectedFilter,
  toggleExpandCollapse,
}) => {
  const { kind, multi = false } = customFilterConfig || {};

  // Common base configuration
  const commonConfig = {
    name,
    label: '',
    isRequired: false,
    isNewFilter: true,
    isAppendToBody: true,
    expanded,
    components: {
      ValueContainer: (customProps) => (
        <CustomValueContainer
          {...customProps}
          expanded={expanded}
          selectedFilter={selectedFilter}
          toggleExpandCollapse={toggleExpandCollapse}
        />
      ),
    },
  };

  switch (kind) {
    case 'number':
      return {
        ...commonConfig,
        type: 'plainInput',
        inputType: 'number',
        isMulti: false,
        isBoolean: false,
        isCompare: true,
        styles: {
          fontSize: '12px',
          height: '36px',
          border: '1px solid #D9D9D9',
          borderRadius: '8px',
        },
      };

    case 'rel_tag':
      return {
        ...commonConfig,
        type: 'select',
        options: customFilterConfig?.values?.map((itr) => ({
          label: itr?.value,
          value: itr?.id,
        })),
        validationType: 'array',
        isMulti: customFilterConfig?.multi,
        isCompare: false,
        isBoolean: false,
        isSearchable: true,
      };

    case 'enum_boolean':
      return {
        ...commonConfig,
        type: 'select',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' },
        ],
        validationType: 'boolean',
        isMulti: false,
        isCompare: false,
        isBoolean: true,
        isAppendToBody: true,
      };

    case 'date':
      return {
        ...commonConfig,
        type: 'filterDatePicker',
        validationType: 'date',
        isCompare: true,
        isMulti: false,
        isBoolean: false,
        isCustomize: true,
        fieldKey: 'date',
      };

    case 'singleText':
      return {
        ...commonConfig,
        type: 'plainInput',
        inputType: 'text',
        isMulti: false,
        isBoolean: false,
        isCompare: false,
        isSearchable: false,
        validationType: 'string',
      };

    case 'rel_tag_multi':
      return {
        ...commonConfig,
        type: 'select',
        options: customFilterConfig?.values?.map((itr) => ({
          label: itr?.value,
          value: itr?.id,
        })),
        validationType: 'array',
        isMulti: true,
        isCompare: false,
        isBoolean: false,
        isSearchable: true,
      };

    case 'enum':
      return {
        ...commonConfig,
        type: 'select',
        options: customFilterConfig?.values?.map((itr) => ({
          label: itr?.value,
          value: itr?.id,
        })),
        validationType: 'array',
        isMulti: multi,
        isCompare: false,
        isBoolean: false,
        isSearchable: true,
      };

    default:
      // Fallback for unknown types - treat as select with custom values if available
      if (customFilterConfig?.values && customFilterConfig?.values?.length > 0) {
        return {
          ...commonConfig,
          type: 'select',
          options: customFilterConfig?.values?.map((itr) => ({
            label: itr?.value,
            value: itr?.id,
          })),
          validationType: 'array',
          isMulti: multi,
          isCompare: false,
          isBoolean: false,
          isSearchable: true,
        };
      }
      // Fallback to plainInput for unknown types without values
      return {
        ...commonConfig,
        type: 'plainInput',
        inputType: 'text',
        isMulti: false,
        isBoolean: false,
        isCompare: false,
        isSearchable: false,
        validationType: 'string',
      };
  }
};
